import axios from 'axios'
const baseURL = import.meta.env.PROD
  ? 'https://api.gonextmaker.com/api'
  : '/api';

const api = axios.create({
  baseURL,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  },
  timeout: 10000
})

// Intercepteur pour les requêtes
api.interceptors.request.use(
  (config) => {
    console.log('API Request:', config.method?.toUpperCase(), config.url);
    
    // Ajouter le token d'auth si disponible
    const authToken = localStorage.getItem('auth_token');
    if (authToken) {
      config.headers['Authorization'] = `Bearer ${authToken}`;
    }
    
    return config;
  },
  (error) => {
    console.error('Request error:', error);
    return Promise.reject(error);
  }
);

// Intercepteur pour les réponses
api.interceptors.response.use(
  response => {
    console.log('API Response:', response.status, response.data);
    
    // October CMS retourne souvent les données dans une propriété spécifique
    if (response.data && typeof response.data === 'object') {
      // Si la réponse contient des données October standard
      if (response.data.result) {
        return { ...response, data: response.data.result };
      }
    }
    
    return response;
  },
  error => {
    console.error('API Error:', error.response?.status, error.response?.data);
    
    // Gestion spécifique des erreurs October CMS
    if (error.response?.data?.error) {
      console.error('October CMS Error:', error.response.data.error);
    }
    
    if (error.response?.status === 403) {
      console.error('Accès refusé');
      // Redirection vers la page de login si accès refusé
      localStorage.removeItem('auth_token');
      localStorage.removeItem('user');
      window.location.href = 'https://app.gonextmaker.com/auth/login';
    }
    
    if (error.response?.status === 401) {
      console.error('Non authentifié');
      localStorage.removeItem('auth_token');
      localStorage.removeItem('user');
      window.location.href = 'https://app.gonextmaker.com/auth/login';
    }
    
    // Gérer les timeouts et erreurs réseau
    if (error.code === 'ECONNABORTED') {
      console.error('Timeout de la requête');
      return Promise.reject(new Error('La requête a pris trop de temps. Veuillez réessayer.'));
    }
    
    if (!error.response) {
      console.error('Erreur réseau');
      return Promise.reject(new Error('Problème de connexion réseau. Veuillez vérifier votre connexion.'));
    }
    
    // Gérer les réponses HTML (typique d'October CMS quand la route n'existe pas)
    if (error.response?.headers?.['content-type']?.includes('text/html')) {
      console.error('Route API non trouvée - Vérifiez la configuration backend');
      return Promise.reject(new Error('Endpoint API non trouvé. Vérifiez la configuration.'));
    }
    
    return Promise.reject(error);
  }
)

export default api